"use script";

angular.module("core")
.constant("IMPORT_LOG_TYPE", {
    "GOODS_RECEIPT": "goods_receipt",
    "GOODS_TRANSFER": "goods_transfer",
    "INVOICE": "invoice"
});



//////////////////
// WEBPACK FOOTER
// ./core/import-logs/import-log-type.constant.js
// module id = 384
// module chunks = 0